import React, { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { css } from '@emotion/core';
import i18next from 'i18next';
import { functional } from '@fever/ui';
import { errMsgWrapperStyle } from 'features/login/styles/comman';
import { removeBtnDefaultStyle } from 'styles/common';
import { setTextVariantStyle } from 'utils/text';

const OtpResendButton = ({ onResend = () => {} }) => {
    const [cooldownTime, setCooldownTime] = useState(0);
    const [isResending, setIsResending] = useState(false);

    useEffect(() => {
        if (cooldownTime > 0) {
            const timer = setInterval(() => {
                setCooldownTime(prev => prev - 1);
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [cooldownTime]);

    const handleResend = async () => {
        if (cooldownTime > 0 || isResending) return;

        try {
            setIsResending(true);
            await onResend();
            setCooldownTime(300); // 5 min cooldown
        } catch (error) {
            console.error('Resend failed:', error);
        } finally {
            setIsResending(false);
        }
    };

    const isDisabled = cooldownTime > 0 || isResending;

    return (
        <div css={containerStyle}>
            <Typography variant="caption" css={expiredTextStyle}>
                <span css={[errMsgWrapperStyle, css(`padding: 0px;`)]}>
                    {i18next.t('label.verification_code_expired')}，
                </span>
                <button css={resendButtonStyle} onClick={handleResend} disabled={isDisabled}>
                    <span css={buttonTextStyle}>
                        {isResending
                            ? i18next.t('label.resending')
                            : cooldownTime > 0
                            ? `${i18next.t('label.resend')} (${cooldownTime}s)`
                            : i18next.t('label.resend')}
                    </span>
                </button>
            </Typography>
        </div>
    );
};

const containerStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 480px) {
        gap: 6px;
        padding: 0 12px;
    }

    @media (max-width: 360px) {
        gap: 4px;
        padding: 0 8px;
    }
`;

const expiredTextStyle = css`
    ${setTextVariantStyle('subtitle2')}
    display: inline-flex;
    padding: 0;
`;

const resendButtonStyle = css`
    ${removeBtnDefaultStyle}
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover:not(:disabled) {
        opacity: 0.8;
    }

    &:disabled {
        cursor: not-allowed;
    }
`;

const buttonTextStyle = css`
    color: ${functional};

    button:hover:not(:disabled) & {
        color: ${functional};
    }

    button:disabled & {
        color: ${functional};
    }
`;

export default OtpResendButton;
